var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 51,
    viewBox: "0 0 60 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1333 46.9281L30.2446 4.61123L4.87025 46.9281H55.1333ZM33.5276 2.22021L58.7919 45.1755C60.3035 47.7457 58.47 51.0007 55.5106 51.0007H4.48919C1.51527 51.0007 -0.316134 47.7169 1.22466 45.1473L26.9818 2.19202C28.4747 -0.297723 32.0558 -0.282302 33.5276 2.22021ZM29.9998 33.6673C28.5155 33.6673 27.333 32.5001 27.333 31.0007V19.0007C27.333 17.5012 28.5155 16.334 29.9998 16.334C31.4842 16.334 32.654 17.5012 32.654 19.0007V31.0007C32.654 32.5001 31.4842 33.6673 29.9998 33.6673ZM32.6665 40.334C32.6665 41.8335 31.4842 43.0007 29.9998 43.0007C28.5155 43.0007 27.3332 41.8335 27.3332 40.334C27.3332 38.8345 28.5155 37.6673 29.9998 37.6673C31.4842 37.6673 32.6665 38.8345 32.6665 40.334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d6e8add092b5e035a2ab7eb44a5e72be.svg";
export { ForwardRef as ReactComponent };